import React from "react";

import { SiteNotiIcon } from "../SVGIcons";

interface EnterpriseRequiredNotiProps {
  planType?: string;
}

const EnterpriseRequiredNoti: React.FC<EnterpriseRequiredNotiProps> = ({
  planType,
}) => {
  return (
    <div className="max-w-8xl mx-auto px-4 mt-4">
      <div className="flex bg-yellow-50 p-3 rounded-md border border-yellow-500">
        <div>
          <SiteNotiIcon />
        </div>
        <div className="ml-3 text-yellow-700 text-sm leading-relaxed">
          <div className="mb-2">
            この画面は、契約プランがEnterprise専用の画面です。
          </div>
          <div className="mb-2">
            現在の契約プランは<strong>{planType || "不明"}</strong>
            であるため、アプリ管理者ユーザーのみ利用が可能となります。
          </div>
          <div className="text-red-600">
            ※契約プランの変更によりアカウントの上限回数が減少した場合、以下現象がみられる場合がございます。
            <ul className="list-disc ml-5 mt-1">
              <li>・割振可能なクレジット数がマイナスになる。</li>
              <li>・割振率が100%を超える。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseRequiredNoti;
